<div class="container pb-5">
    <div class="row">
       <div class="col col-sm-3">
          <b3-button type="button" variant="outlined" tone="default" (b3-click)="navigateToProjectConsult()">
             <b3-icon name="arrow_back" size="md"></b3-icon>
             Voltar
          </b3-button>
       </div>
       <div class="col col-sm-6">
       </div>
       <div class="col col-sm-3 d-flex justify-content-end">
          <b3-button class="ml-md-2" type="button" variant="filled" tone="default" (b3-click)="exportToCSV()">
             <b3-icon name="arrow_downward" size="md" tone="on-brand"></b3-icon>
             Exportar
          </b3-button>
       </div>
    </div>
    <div class="row">
       <div class="col col-sm-12">
          <ol class="viz-status-steps" aria-label="Status do projeto">
             <li
                [class.completed]="isProjectCompleted"
                [class.error]="isProjectCompletedError"
                [class.active]="steperSelectindex === 0">
                Projeto enviado
             </li>
             <li
                [class.completed]="isAuditCompleted"
                [class.error]="isAuditCompletedError"
                [class.active]="steperSelectindex === 1">
                Pendente de verificação do auditor
             </li>
             <li
                [class.completed]="isReportCompleted"
                [class.error]="isReportCompletedError"
                [class.active]="steperSelectindex === 2">
                Aguardando recebimento do relatório
             </li>
             <li
                [class.completed]="isRegisteredCompleted"
                [class.error]="isRegisteredCompletedError"
                [class.active]="steperSelectindex === 3">
                Projeto registrado na B3
             </li>
          </ol>
       </div>
    </div>
    <div class="div-info">
      <div class="title-row">
         <h3>1. Dados Gerais</h3>
      </div>
       
      <div class="subtitle-info">
         <h3>Detalhes do projeto</h3>
      </div>
      <div class="row">
          <div class="col col-sm-8">
             <p class="p">Nome do projeto:</p>
             <b class="b">{{projectData?.projectName}}</b>
          </div>
      </div>
      <div class="row">
         <div class="col col-sm-3">
            <p class="p">Conta registrador:</p>
            <b class="b">{{projectData?.registerCode}}</b>
         </div>
         <div class="col col-sm-3">
           <p class="p">Data de início do projeto:</p>
           <b class="b">{{projectData?.projectStartDate}}</b>
        </div>
        <div class="col col-sm-3">
           <p class="p">Atividade de linha de base:</p>
           <b class="b">{{baselineActivity}}</b>
        </div>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <p class="p">Status:</p>
            <b class="b">{{projectData?.status}}</b>
         </div>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <p class="p">Descrição do projeto:</p>
            <b class="b">{{projectData?.generalDetails}}</b>
         </div>
      </div>
      <div class="separator"></div>

      <div class="subtitle-info">
         <h3>Desenvolvedor principal</h3>
      </div>
      <div class="row">
         <div class="col col-sm-6">
            <p class="p">Razão social:</p>
            <b class="b">{{developerPrincipal?.developerName}}</b>
         </div>
         <div class="col col-sm-6">
            <p class="p">CPF/CNPJ:</p>
            <b class="b">{{developerPrincipal?.cpfCnpj}}</b>
         </div>
      </div>
      <div class="row">
         <div class="col col-sm-6">
            <p class="p">E-mail:</p>
            <b class="b">{{developerPrincipal?.email}}</b>
         </div>
         <div class="col col-sm-6">
            <p class="p">Telefone:</p>
            <b class="b">{{developerPrincipal?.phone}}</b>
         </div>
      </div>
      <div class="separator"></div>

      <div class="subtitle-info">
         <h3>Outros desenvolvedores</h3>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <div class="table-container">
               <b3-table size="sm" background="striped" aria-label="Outros desenvolvedores">
                  <b3-table-rowgroup group="header">
                     <b3-table-row>
                        <b3-table-cell-header label="Razão Social"></b3-table-cell-header>
                        <b3-table-cell-header label="CPF/CNPJ"></b3-table-cell-header>
                     </b3-table-row>
                  </b3-table-rowgroup>
                  <b3-table-rowgroup group="body">
                     <b3-table-row *ngFor="let row of othersDevelopers">
                        <b3-table-cell variant="text" [label]="row.developerName || '-'"></b3-table-cell>
                        <b3-table-cell variant="text" [label]="formatDocument(row.cpfCnpj)"></b3-table-cell>
                     </b3-table-row>
                  </b3-table-rowgroup>
               </b3-table>
            </div>
         </div>
      </div>
    </div>
    <div class="div-info">
      <div class="title-row">
         <h3>2. Propriedades</h3>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <div class="table-container">
               <div class="table-section-overflow">
                  <div class="table-overflow-row">
                     <b3-table size="sm" background="striped" aria-label="Propriedades do projeto">
                        <b3-table-rowgroup group="header">
                           <b3-table-row>
                              <b3-table-cell-header label="Proprietário"></b3-table-cell-header>
                              <b3-table-cell-header label="CPF/CNPJ"></b3-table-cell-header>
                              <b3-table-cell-header label="Coordenadas"></b3-table-cell-header>
                              <b3-table-cell-header label="País"></b3-table-cell-header>
                              <b3-table-cell-header label="UF"></b3-table-cell-header>
                              <b3-table-cell-header label="Município"></b3-table-cell-header>
                              <b3-table-cell-header label="Hectares totais"></b3-table-cell-header>
                              <b3-table-cell-header label="Hectares de geração de carbono"></b3-table-cell-header>
                              <b3-table-cell-header label="Hectares disponíveis"></b3-table-cell-header>
                              <b3-table-cell-header label="Bioma"></b3-table-cell-header>
                              <b3-table-cell-header label="CAR. Registro de inscrição"></b3-table-cell-header>
                              <b3-table-cell-header label="CAR. Link do demonstrativo online"></b3-table-cell-header>
                           </b3-table-row>
                        </b3-table-rowgroup>
                        <b3-table-rowgroup group="body">
                           <b3-table-row *ngFor="let row of locations">
                              <b3-table-cell variant="text" [label]="row.landOwnerFullName || '-'"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="formatDocument(row.landOwnerCpfCnpj)"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="row.coordinates || '-'"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="row.country || '-'"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="row.state || '-'"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="row.municipality || '-'"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="row.totalHectares ?? '-'"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="row.carbonGenerationHectares ?? '-'"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="row.availableHectares ?? '-'"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="formatBiome(row.biome)"></b3-table-cell>
                              <b3-table-cell variant="text" [label]="row.registrationRecord || '-'"></b3-table-cell>
                              <b3-table-cell variant="slot">
                                 <ng-container *ngIf="row.registrationRecordLink; else missingLocationLink">
                                    <a
                                       [href]="row.registrationRecordLink"
                                       class="link"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                       {{ row.registrationRecordLink }}
                                    </a>
                                 </ng-container>
                                 <ng-template #missingLocationLink><span>-</span></ng-template>
                              </b3-table-cell>
                           </b3-table-row>
                        </b3-table-rowgroup>
                     </b3-table>
                  </div>
               </div>
            </div>
         </div>
      </div>
    </div>
    <div class="div-info">
      <div class="title-row">
         <h3>3. Metodologia</h3>
      </div>
      <div class="row">
         <div class="col col-sm-3">
            <p class="p">Metodologia:</p>
            <b class="b">{{methodology}}</b>
         </div>
      </div>
      <div class="separator"></div>

      <div class="subtitle-info">
         <h3>Relatório de Adequação à Metodologia (RA)</h3>
      </div>
      <div class="row">
         <div class="col col-sm-6">
            <p class="p">Link do relatório:</p>
            <a href={{projectData?.methodologyReportLink}} class="link-info"  target="_blank">{{projectData?.methodologyReportLink}}</a>
         </div>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <p class="p">Descrição do relatório:</p>
            <b class="b">{{projectData?.methodologyDocumentDescription}}</b>
         </div>
      </div>
      <div class="separator"></div>
      
      <div class="subtitle-info">
         <h3>Outros documentos relevantes:</h3>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <p class="p">Descrição das documentações:</p>
            <b class="b">{{projectData?.otherDocumentationDescription}}</b>
         </div>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <div class="table-container">
               <b3-table size="sm" background="striped" aria-label="Outros documentos relevantes">
                  <b3-table-rowgroup group="header">
                     <b3-table-row>
                        <b3-table-cell-header label="Link"></b3-table-cell-header>
                     </b3-table-row>
                  </b3-table-rowgroup>
                  <b3-table-rowgroup group="body">
                     <b3-table-row *ngFor="let row of attachments">
                        <b3-table-cell variant="slot">
                           <ng-container *ngIf="row.link; else missingAttachmentLink">
                              <a
                                 [href]="row.link"
                                 class="link"
                                 target="_blank"
                                 rel="noopener noreferrer">
                                 {{ row.link }}
                              </a>
                           </ng-container>
                           <ng-template #missingAttachmentLink><span>-</span></ng-template>
                        </b3-table-cell>
                     </b3-table-row>
                  </b3-table-rowgroup>
               </b3-table>
            </div>
         </div>
      </div>
    </div>
    <div class="div-info">
      <div class="title-row">
         <h3>4. Co-benefícios</h3>
      </div>

      <div class="subtitle-info">
         <h3>ODS (Objetivos de Desenvolvimento Sustentável) incorporados ao RA</h3>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <div class="table-container">
               <b3-table size="sm" background="striped" aria-label="ODS selecionados">
                  <b3-table-rowgroup group="header">
                     <b3-table-row>
                        <b3-table-cell-header label="ODS Selecionado(s)"></b3-table-cell-header>
                     </b3-table-row>
                  </b3-table-rowgroup>
                  <b3-table-rowgroup group="body">
                     <b3-table-row *ngFor="let row of odsSelecteds">
                        <b3-table-cell variant="text" [label]="row.description || '-'"></b3-table-cell>
                     </b3-table-row>
                  </b3-table-rowgroup>
               </b3-table>
            </div>
         </div>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <p class="p">Outros co-benefícios:</p>
            <b class="b">{{projectData?.coBenefits}}</b>
         </div>
      </div>
    </div>
 
   <div class="row d-flex justify-content-end">
      <!-- Auditor Rejeitar Projeto-->
      <div *ngIf="isButtonAuditRejectProject"  class="col col-sm-4 d-flex justify-content-end">
         <b3-button type="button" variant="outlined" tone="default" (b3-click)="actionAuditRejectProject()">
            Rejeitar Projeto
         </b3-button>
      </div>
      <!-- Auditor Aprovar Projeto-->
      <div *ngIf="isButtonAuditApproveProject" class="col col-sm-4 d-flex justify-content-end">
         <b3-button type="button" variant="filled" tone="default" (b3-click)="actionAuditAproveProject()">
            Aprovar Projeto
         </b3-button>
      </div>

      <!-- Desenvolvedor Rejeitar Recebimento do Relatorio-->
      <div *ngIf="isButtonUserRejectReport"  class="col col-sm-4 d-flex justify-content-end">
         <b3-button
            type="button"
            variant="outlined"
            tone="default"
            [disabled]="projectData?.showReason || false"
            (b3-click)="actionDeveloperRejectReportRecieved()">
            Rejeitar Recebimento do RM
         </b3-button>
      </div>
      <!-- Desenvolvedor Aprovar Recebimento do Relatorio-->
      <div *ngIf="isButtonUserAproveReport" class="col col-sm-4 d-flex justify-content-end">
         <b3-button type="button" variant="filled" tone="default" (b3-click)="actionDeveloperAproveReportRecivied()">
            Confirmar Recebimento do RM
         </b3-button>
      </div>

      <!-- Clonar Projeto-->
      <div *ngIf="isButtonCloneProject && !isReportCompletedError" class="col col-sm-3 d-flex justify-content-end">
         <b3-button type="button" variant="filled" tone="default" (b3-click)="actionCloneProject()">
            Clonar Projeto
         </b3-button>
      </div>
   </div>
 </div>
